import { render, staticRenderFns } from "./HallOfFame.vue?vue&type=template&id=722e47a0&scoped=true"
import script from "./HallOfFame.vue?vue&type=script&lang=js"
export * from "./HallOfFame.vue?vue&type=script&lang=js"
import style0 from "./HallOfFame.vue?vue&type=style&index=0&id=722e47a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722e47a0",
  null
  
)

export default component.exports